import axios from "axios";
import BASE_URL from "../../../constants/baseURL";

export default async function signOut(_, { getState }) {
  const { memberDetails } = getState();

  await axios({
    baseURL: BASE_URL.digipass.url + BASE_URL.digipass.version,
    url: "/visitor/logout",
    method: "POST",
    headers: {
      Authorization: "Bearer " + memberDetails.authToken,
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      console.log("res.data.data", res);

      sessionStorage.clear();
      localStorage.removeItem("authToken");
      localStorage.removeItem("auth_token_with_guard");
      localStorage.removeItem("visitorDataID");
    })
    .catch((err) => {
      console.log("err", err == "Error: Request failed with status code 401");
      return err;
    });
}
